import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#0B0F14] disabled:opacity-50 disabled:cursor-not-allowed uppercase tracking-wide';
  const variants = {
    primary: 'bg-[#E10600] text-white hover:bg-[#FF2D2D] focus:ring-[#E10600] shadow-[0_0_15px_rgba(225,6,0,0.3)] hover:shadow-[0_0_25px_rgba(225,6,0,0.5)] border border-transparent',
    secondary: 'bg-[#1a1f2b] text-white border border-[#2a2f3b] hover:border-[#E10600] hover:text-[#E10600] focus:ring-[#6B7280]',
    outline: 'border-2 border-[#E10600] text-[#E10600] bg-transparent hover:bg-[#E10600] hover:text-white focus:ring-[#E10600]',
    ghost: 'text-[#6B7280] hover:text-white hover:bg-white/5 focus:ring-[#6B7280]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-xs',
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-lg'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} {...props} data-id="element-355">
      {children}
    </button>;
}